const isFilledUp = maybeFilledUp => {
  switch (typeof maybeFilledUp) {
    case 'string':
      return maybeFilledUp.trim() !== ''
    case 'number':
      return !Number.isNaN(maybeFilledUp)
    default:
      break
  }
  return !!maybeFilledUp
}

export default isFilledUp
